// test2047
(2047 && 0);
